import { createContext, useContext } from 'react'

import type { AuthSession } from './session'

export interface AuthState {
  session: AuthSession | null

  isLoading: boolean

  refresh: () => Promise<void>

  signOut: () => Promise<void>

  endSessionLocally: () => void
}

export const AuthContext = createContext<AuthState | undefined>(undefined)

export const AUTH_SESSION_KEY = ['auth', 'session'] as const

export function useAuth(): AuthState {
  const value = useContext(AuthContext)

  if (!value) {
    throw new Error('useAuth must be used inside an AuthProvider')
  }

  return value
}
